import { jsx as i, jsxs as v } from "react/jsx-runtime";
function L(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var _ = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var f;
function w() {
  return f || (f = 1, function(n) {
    (function() {
      var c = {}.hasOwnProperty;
      function e() {
        for (var t = "", r = 0; r < arguments.length; r++) {
          var o = arguments[r];
          o && (t = u(t, a(o)));
        }
        return t;
      }
      function a(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return e.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var r = "";
        for (var o in t)
          c.call(t, o) && t[o] && (r = u(r, o));
        return r;
      }
      function u(t, r) {
        return r ? t ? t + " " + r : t + r : t;
      }
      n.exports ? (e.default = e, n.exports = e) : window.classNames = e;
    })();
  }(_)), _.exports;
}
var q = w();
const x = /* @__PURE__ */ L(q), A = "_button_q469y_13", j = "_button__icon_q469y_47", I = "_button_dark_q469y_57", N = "_button_secondary_q469y_62", O = "_button_isWide_q469y_116", S = "_button_hasIconLeft_q469y_120", R = "_button_small_q469y_124", s = {
  button: A,
  button__icon: j,
  button_dark: I,
  button_secondary: N,
  button_isWide: O,
  button_hasIconLeft: S,
  button_small: R
};
var W = /* @__PURE__ */ ((n) => (n.PRIMARY = "primary", n.SECONDARY = "secondary", n))(W || {}), g = /* @__PURE__ */ ((n) => (n.LIGHT = "light", n.DARK = "dark", n))(g || {}), k = /* @__PURE__ */ ((n) => (n.DEFAULT = "default", n.SMALL = "small", n))(k || {});
function D() {
  return /* @__PURE__ */ i(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ i(
        "path",
        {
          d: "M6 12L10 8L6 4",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function M({
  id: n,
  uid: c,
  children: e,
  icon: a,
  hasIconLeft: u,
  isWide: t,
  onClick: r,
  ariaLabel: o,
  isDisabled: l,
  variant: b = "primary",
  mode: d = "light",
  size: p = "default"
  /* DEFAULT */
}) {
  async function y(h) {
    l || await (r == null ? void 0 : r(h));
  }
  const m = {
    id: n,
    uid: c,
    className: x(
      s.button,
      s[`button_${b}`],
      s[`button_${p}`],
      s[`button_${d}`],
      {
        [s.button_isWide]: t,
        [s.button_hasIconLeft]: u
      }
    ),
    onClick: y,
    "aria-label": o,
    disabled: l
  };
  return /* @__PURE__ */ v("button", { ...m, children: [
    a && /* @__PURE__ */ i("span", { className: s.button__icon, children: a }),
    /* @__PURE__ */ i("span", { className: s.button__text, children: e })
  ] });
}
export {
  D as A,
  W as B,
  g as a,
  k as b,
  M as c,
  x as d
};
